import { styled } from '@linaria/react';
import { BaseEdge, EdgeLabelRenderer, EdgeProps, getStraightPath } from '@xyflow/react';
import { baseWhite, primaryBase } from '../../../../styles/design-tokens';
import { Tooltip } from '../../../../ui-library/tooltip/tooltip';
import { Text } from '../../../../ui-library/typography/typography';
import { TaskTransition } from '../../../tasks-table/tasks-table.type';
import { formatAgenticProcessDate } from '../../agentic-process-helpers';

export const TaskStatusEdge = ({ sourceX, sourceY, targetX, targetY, style = {}, data }: EdgeProps) => {
  const taskTransition = data?.taskTransition as TaskTransition;
  const isCurrentStatus = data?.isCurrentStatus as boolean;
  const statusName = data?.statusName as string;
  const startTime = data?.startTime as string;
  const endTime = data?.endTime as string;

  const [edgePath, labelX, labelY] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  const getTooltipContent = () => {
    if (!taskTransition) return '';

    return (
      <div>
        <Text>
          Status: {taskTransition.status} {isCurrentStatus ? '(CURRENT)' : ''}
        </Text>
        {taskTransition.changed_by && <Text>Changed by: {taskTransition.changed_by}</Text>}
        <Text>
          {startTime ? formatAgenticProcessDate(startTime) : 'Start'} -{' '}
          {endTime ? formatAgenticProcessDate(endTime) : 'Present'}
        </Text>
      </div>
    );
  };

  return (
    <>
      <BaseEdge
        path={edgePath}
        style={{
          stroke: primaryBase,
          strokeWidth: isCurrentStatus ? 3 : 2,
          ...style,
        }}
      />
      <EdgeLabelRenderer>
        {taskTransition && (
          <Tooltip label={getTooltipContent()} variant="black" multiline>
            <TaskStatusLabel
              style={{
                transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              }}
            >
              <Text size="small" weight={isCurrentStatus ? 'bold' : 'regular'}>
                {statusName || taskTransition?.status}
              </Text>
            </TaskStatusLabel>
          </Tooltip>
        )}
      </EdgeLabelRenderer>
    </>
  );
};

const TaskStatusLabel = styled.div`
  position: absolute;
  pointer-events: all;
  z-index: 10;
  background-color: ${baseWhite};
  border-radius: 4px;
  padding: 2px 6px;
  border: 1px solid ${primaryBase};
  cursor: pointer;
  font-style: italic;
  box-shadow: none;
`;
